<swiper-container autoplay="true" loop="true" slides-per-view="1">
  <swiper-slide lazy="false"
    ><a routerLink="/search">Free Shipping on Orders over ${{free_shipping_threshold}}</a></swiper-slide
  >
  <swiper-slide lazy="false"
    ><a [routerLink]="['collection',bestSellersNo]"
      >You Look Beautiful</a
    ></swiper-slide
  >
  <swiper-slide lazy="false"
    ><a [routerLink]="['collection',newArrivalsNo]"
      >Welcome to {{appname}}</a
    ></swiper-slide
  >
  <swiper-slide lazy="false"
    ><a [routerLink]="['collection',bestSellersNo]"
      >Discover Your Unique Style</a
    ></swiper-slide
  >
  <swiper-slide lazy="false"
    ><a [routerLink]="['collection',newArrivalsNo]"
      >New Arrivals Just for You</a
    ></swiper-slide
  >
</swiper-container>
